/* Project Import will be here */
import { post, IRequest } from "../index";
import { IExchangeSubmitParams } from "models/salesReturnModels";
/* Project Import will be here */

export const exchangeSubmitApi = (data: IExchangeSubmitParams) => {
    const request: IRequest = {
        subUrl: `/SalesReturn/ExchangeSubmit`,
        data
    };

    return post(request);
};

/* Get delivery date for exchange return module */
export const getDeliveryDateApi = () => {
    const request: IRequest = {
        subUrl: `/Appconfig/GetDeliveryDate`
    };

    return post(request);
};

